module.exports = __webpack_public_path__ + "static/UTsm-631586f9141236a2a1b364c9c1158531.png";